import { useEffect, useState } from "react";
import { FosterTable } from "./FosterTable/FosterTable";
import { fosterList } from "../../../api/FosterSubmit";
import { useSelector } from "react-redux";

const PAGE_SIZE = 50;

export default function FosterList() {
  const [localUserData, setLocalUserData] = useState(null);
  const [fosterData, setFosterData] = useState(null);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const userData = useSelector((state) => state.userData.userData);

  useEffect(() => {
    if (Object.keys(userData).length !== 0) {
      setLocalUserData(JSON.parse(userData));
    }
  }, [userData]);

  useEffect(() => {
    if (localUserData) {
      getFosterList(page);
    }
  }, [localUserData, page]);

  const getFosterList = async (p) => {
    try {
      const response = await fosterList(p);
      if (response) {
        setFosterData(response.results || []);
        setTotalCount(response.count || 0);
        setPageCount(Math.ceil((response.count || 0) / PAGE_SIZE));
      }
    } catch (error) {
      console.error("Error getting Fosters: ", error);
    }
  };

  return (
    <div className="flex-1 bg-gray-100 min-h-screen p-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="!text-[30px] !font-bold !font-poppins text-blue-navy text-left">
          Fosters
        </h1>
        <p className="!text-sm text-gray-500 mt-1 mb-6 text-left">
          Keep track of all your fosters.
        </p>

        <div className="bg-white rounded-2xl shadow-md overflow-hidden">
          {fosterData ? (
            <FosterTable
              data={fosterData}
              serverPagination={true}
              serverPageCount={pageCount}
              serverTotalCount={totalCount}
              onServerPageChange={setPage}
            />
          ) : (
            <div className="p-8 text-center text-gray-400 text-sm">
              Loading fosters...
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
